import React from 'react';
import PropTypes from 'prop-types';

// Components
import SVG from 'components/widgets/icons/svg';


export default function TransferOption({ call }) {
  return (
    <div>
      <div onClick={() => call.setOpen('transfer')} className="triage-option-transfer triage-option-header">
        <SVG src="svg/transfer.svg" className="transfer triage-option-icon" />
        <span>Transfer</span>
      </div>
    </div>
  );
}

TransferOption.propTypes = {
  call: PropTypes.object.isRequired
};
